import { Tooltip, tooltipClasses, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import Logo_ from '../../assets/images/logo/logo192.png';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        align-items: center;
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
        width: 100%;
        height: 100%;
        justify-content: flex-start;
        overflow: hidden;
`
);

const ResponsiveLogo = styled('img')(
  ({ theme }) => `
    height: 58px;
    width: auto;
    display: block;
    max-width: 100%;

    @media (min-width: ${theme.breakpoints.values.sm}px) {
        height: 62px;
    }

    @media (min-width: ${theme.breakpoints.values.md}px) {
        height: 68px;
    }

    @media (min-width: ${theme.breakpoints.values.lg}px) {
        height: 74px;
    }
`
);

const TooltipWrapper = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    borderRadius: theme.general.borderRadiusSm,
    boxShadow:
      '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100]
  }
}));

function Logo() {
  return (
    <TooltipWrapper title="Home" arrow>
      <LogoWrapper to="/dashboards/tasks">
        <ResponsiveLogo alt="Logo" src={Logo_} />
      </LogoWrapper>
    </TooltipWrapper>
  );
}

export default Logo;
